import React from "react";
import Header from "../Home/Header";
import AMMDexHero from "./AMMDexHero";
import WhatIsAMM from "./WhatIsAMM";
import Footer from "../Home/Footer";
import AMMDexDev from "./AMMDexDev";
import ConstantProductAMM from "./ConstantProductAMM";
import StunningFeatures from "./StunningFeatures";
import BlockchainExpertise from "./BlockchainExpertise";
import WhyChoose from "../Wallet/NFT Wallet/WhyChoose";

function AMMDex() {
  return (
    <div>
      <Header />
      <AMMDexHero />
      <WhatIsAMM />
      <AMMDexDev />
      <ConstantProductAMM />
      <StunningFeatures />
      {/* <BlockchainExpertise /> */}
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default AMMDex;
